/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useState } from "react"
import {
    TitleSection,
    ModalTitle,
    ContentSection,
    Column,
    Label,
    Color,
    Row,
    Element,
    Button,
    Icon,
    isSmallMobileScreen,
    FooterSection,
} from "trux"

export const PlayerOrFamily = ({ loggedInUser, ...props }) => {
    const [selected, setSelected] = useState(null)
    const [error, setError] = useState(null)

    console.log("loggedinUser at playerorfamily step", loggedInUser)

    const onContinue = () => {
        if (!selected) {
            setError("You must select a role to continue")
        } else {
            props.onWhoSelected(selected)
        }
    }

    const onButtonClick = (buttonId) => {
        if (error) setError(null)
        setSelected(buttonId)
    }

    return (
        <>
            <TitleSection>
                <ModalTitle content={"Who are you?"} />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Label
                        center
                        type={Label.Type.Body}
                        color={Color.Charcoal40}
                        content={`Let's set up ${loggedInUser.first_name}'s family account.`}
                        marginBottom="2"
                    />
                    <Row center>
                        <Label
                            small
                            type={Label.Type.Body}
                            color={Color.Charcoal40}
                            content="Invited email:&nbsp;"
                        />{" "}
                        <Label
                            bold
                            small
                            type={Label.Type.Body}
                            color={Color.Charcoal40}
                            content={loggedInUser.email}
                            marginBottom="8"
                        />
                    </Row>

                    <Row marginBottom="8">
                        <Element
                            marginRight="4"
                            className={`big-button ${
                                selected === "self" ? "selected" : ""
                            }`}
                            onClick={() => onButtonClick("self")}
                        >
                            <Element className="contents">
                                {selected === "self" && (
                                    <Element className="selected-check">
                                        <Icon
                                            size={16}
                                            type={Icon.Type.Check}
                                        />
                                    </Element>
                                )}
                                <Label
                                    width="128px"
                                    content={`I'm ${loggedInUser.first_name}`}
                                />
                            </Element>
                        </Element>
                        <Element
                            className={`big-button ${
                                selected === "family" ? "selected" : ""
                            }`}
                            onClick={() => onButtonClick("family")}
                        >
                            <Element className="contents">
                                {selected === "family" && (
                                    <Element className="selected-check">
                                        <Icon
                                            size={16}
                                            type={Icon.Type.Check}
                                            marginBottom="4"
                                        />
                                    </Element>
                                )}
                                <Label
                                    width="128px"
                                    content="I'm a family member"
                                />
                            </Element>
                        </Element>
                    </Row>
                    {error && (
                        <Label
                            bold
                            color={Color.Error}
                            content={error}
                            paddingBottom="8"
                        />
                    )}
                    {!isSmallMobileScreen() && (
                        <Button
                            type={Label.Type.Heading5}
                            onClick={onContinue}
                            span="12"
                            className="button"
                            content={
                                <Row className="button-row">
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Continue"
                                        marginRight="2"
                                    />{" "}
                                    <Icon
                                        size={16}
                                        type={Icon.Type.CheveronRight}
                                    />
                                </Row>
                            }
                        />
                    )}
                </Column>
            </ContentSection>
            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        type={Label.Type.Heading5}
                        onClick={onContinue}
                        span="12"
                        className="button"
                        content={
                            <Row>
                                <Label
                                    type={Label.Type.InnerButton}
                                    content="Continue"
                                    marginRight="2"
                                />{" "}
                                <Icon
                                    size={16}
                                    type={Icon.Type.CheveronRight}
                                />
                            </Row>
                        }
                    />
                </FooterSection>
            )}
        </>
    )
}
